const Specifications = () => {
    return (
        <div className="container">
          <h1>Specifications</h1>
          <span className="padding">The Dry for Router Use - LS/RTFF <a className="center button inline" href='./productinfo?product=1'>More Info</a></span>
          <div className="container contentsGroup">
            <img alt="mainProduct" className="imgclassName" src={require('./thedryforrouteruse.gif')} />
    
            <div className="contentsGroup2">
              <ul>
                <li className="liPadding">Hose Diameters: - 51mm(2") or 63mm(2.5") or 76mm(3")</li>
                <li className="liPadding">Motor: - 240v/1200w</li>
                <li className="liPadding">Dimensions: - (approx) Height including Motor - 100cm, Width including handles - 62cm</li>
              </ul>
            </div>
          </div>
    
    
        </div>    
        );
      };
  
  export default Specifications;